.alert {
  color: var(--color-black);
  padding: var(--base-unit-l);
  text-align: center;
  display: block;
  width: 100%;

  &.rounded {
    border-radius: 0.2rem;
  }

  > * {
    margin: 0;
  }
}

.alertWarning {
  background: var(--color-warning);
}

.alertDanger {
  background: var(--color-tertiary);
  color: var(--color-white);
}

.alertSuccess {
  background: var(--color-accent);
}

.alertInfo {
  background: var(--color-primary-light);
  color: var(--color-white);
}
